<div class="row m-b-xs company-view" (dblclick)="editModeOn()">
    <div *ngIf="title"
         [ngClass]="{'col-sm-6': longTitle, 'col-sm-3': !longTitle}"
         class="dv-label strong"
         data-toggle="tooltip"
         data-placement="top"
         [title]="tooltipText">
        {{ title }}
    </div>

    <div *ngIf="!editOnly"
         class="dv-value"
         style="width: 75%;"
         [ngClass]="{'col-sm-6': longTitle, 'hidden': isEditMode, 'col-sm-9': title, 'col-sm-12': !title}">
        <div *ngIf="!isEditMode && value.length > 0" style="display: block;">
            <div class="array-row" *ngFor="let buzz of value; let index = index;">
                <div title="{{buzz.fieldValue}} {{buzz.user ? getUserNameById(buzz.user) : 'Unassigned'}}">
                    {{buzz.fieldValue}}
                    <span *ngIf="userId === null">{{buzz.user ? getUserNameById(buzz.user) : 'Unassigned'}}</span>
                </div>
                <i *ngIf="!noEdit" (click)="removeItem(index)"
                   class="fa fa-trash pull-right" data-toggle="tooltip" data-placement="top" title="Delete"></i>
                <i *ngIf="!noEdit"
                   class="fa fa-pencil pull-right"
                   (click)="editModeOn()"
                   data-toggle="tooltip"
                   data-placement="top"
                   title="Edit"></i>
            </div>
        </div>
        <div class="dv-value array-row" *ngIf="!isEditMode && value.length < 1">
            -
            <i *ngIf="!noEdit"
               class="fa fa-pencil pull-right"
               (click)="editModeOn()"
               data-toggle="tooltip"
               data-placement="top"
               title="Edit"></i>
        </div>
    </div>

    <div class="dv-value-edit" [ngClass]="{'col-sm-6': longTitle, 'hidden': !isEditMode, 'col-sm-9': title, 'col-sm-12': !title}">
        <div *ngFor="let item of value; let index = index;">
            <i *ngIf="icon" [ngClass]="icon" class="m-r-sm"></i>

            <input [(ngModel)]="value[index].fieldValue" class="form-control"
                   maxlength="255" [required]="required" autocomplete="off">

            <select class="form-control" [(ngModel)]="value[index].user" *ngIf="!userId">
                <option [ngValue]="null">Unassigned</option>
                <option *ngFor="let user of suiteUsers; let index = index;" [value]="user.user?.id">
                    {{user.user?.fullName}}
                </option>
            </select>

            <button *ngIf="!editOnly" type="button" (click)="apply()">
                <i class="fa fa-check"></i>
            </button>

            <button *ngIf="!editOnly" type="button" (click)="cancel()">
                <i class="fa fa-times"></i>
            </button>
        </div>
    </div>

    <div class="col-sm-12" *ngIf="isEditMode">
        <i class="icon-plus pull-right" (click)="addNew()" data-toggle="tooltip" data-placement="top" title="Add New Address"></i>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/fields/directory-unit-array-input-field/directory-unit-array-input-field.template.html